import { DatePipe } from '@angular/common';
import { CalendarEventTitleFormatter, CalendarDateFormatter } from 'angular-calendar';
import { ScheduleDateFormatter } from '../../../shared/schedule-date-formatter.provider';
import { ReservationTitleFormatter } from '../reservation-calendar/reservation-title-formatter.provider';
import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FileUploader } from 'ng2-file-upload';
import { ReservationService } from 'projects/qcloud-rest-client/src/lib/reservation.service';
import { ReservationModuleConfiguration } from 'projects/qcloud-models/reservation/reservation-module-configuration';
import { AmmsMappedReservation } from 'projects/qcloud-models/integration/amms-mapped-reservation';
import { AmmsIntegrationService } from 'projects/qcloud-rest-client/src/lib/amms-integration.service';

@Component({
  selector: 'app-reservation-export-csv',
  templateUrl: './reservation-export-csv.component.html',
  styleUrls: ['./reservation-export-csv.component.css'],
  providers: [
    DatePipe,
    {
      provide: CalendarEventTitleFormatter,
      useClass: ReservationTitleFormatter,
    },
    {
      provide: CalendarDateFormatter,
      useClass: ScheduleDateFormatter,
    }
  ]
})
export class ReservationExportCSVComponent implements OnInit {

  @Input() path: string;
  @ViewChild("fileInput") fileInput: ElementRef;
  uploader: FileUploader;
  public rows: AmmsMappedReservation[];
  public displayModule = false;
  public displayFileArray = false;
  public displaySaveButton = false;
  public hasFetchedreservationConfiguration = false;
  public hasReservations = false;
  reservationConfiguration: ReservationModuleConfiguration;

  startDate: Date;
  endDate: Date;

  constructor(private translate: TranslateService,
    private toastr: ToastrService, private reservationService: ReservationService,
    private datePipe: DatePipe, private ammsIntegrationService: AmmsIntegrationService) { }

  ngOnInit(): void {
    this.reservationService.getReservationConfiguration(data => {
      this.reservationConfiguration = data;
      this.hasFetchedreservationConfiguration = true;
      this.displayModule = this.reservationConfiguration.supportsCsvExport;
    }, () => { });

    this.startDate = new Date();
    this.endDate = new Date();



    let startDay = new Date();
    let endDay = new Date();
    let dayCount = 30;
    endDay.setDate(endDay.getDate()+dayCount);

    this.ammsIntegrationService.getAmmsMappedReservations( startDay, endDay, data => {
      this.rows = data;
      this.hasReservations = Boolean(this.rows.length);
      this.displayFileArray = true;
    }, () => {});
  }

  utcDateReservation(reservation: AmmsMappedReservation): AmmsMappedReservation{
    reservation.date = new Date(this.datePipe.transform(reservation.date, 'yyyy-MM-ddTHH:mm:SS') + 'Z');
    return reservation;
  }

  async onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;

    if (target.files && target.files.length > 0) {
      const file = target.files[0];
        if(file.type === 'text/csv')
        {
          await this.csvToArray(file);
          this.hasReservations = true;
          this.displayFileArray = true;
          this.displaySaveButton = true;
        }
        else{
          this.translate.get('file-type-error').subscribe((error: string) => {
            this.toastr.error(error);
            target.value = '';
          });
        }
    }
  }

  csvStringSplit(fileAsString: string): string[][]{
    let rows: string[];
    let fileAsArray: string[][] = [];
    rows = fileAsString.split(/[\r\n]+/g);
    rows.forEach((row: string) => fileAsArray = [ ...fileAsArray, row.split(/[;,]/gm)]);
    fileAsArray = fileAsArray.filter(row => row.length===5 && !row.includes(''));
    return fileAsArray;
  }

  csvToArray(file: File) {
    const reader = new FileReader();
    reader.onload = async (event) => {
      let spreadsheet = await this.csvStringSplit(event.target.result.toString());
      this.rows = spreadsheet.slice(1).map(row => {
        return new AmmsMappedReservation({
        date: new Date(row[0].replace(' ','T')),
        resourceName: row[1],
        locationName: row[2],
        pesel: row[3],
        clientName: row[4]
      });
    });
  }
    reader.readAsText(file);
  }

  onSubmit() {
    let reservations = this.rows.map(r => {return {... r}});
    reservations = reservations.map(r => this.utcDateReservation(r));
    this.ammsIntegrationService.overwriteAmmsMappedReservations( reservations, data => {
      this.translate.get('save-success').subscribe((res: string) => {
        this.toastr.success(res);
      });
    }, () => {
      this.translate.get('save-error').subscribe((error: string) => {
        this.translate.get('repeat').subscribe((res: string) => {
          this.toastr.error(res, error);
        });
    });
  });
    this.displaySaveButton = false;
    this.fileInput.nativeElement.value = '';
  }

  exportFile() {
    this.reservationService.exportReservationsToFile(this.startDate, this.endDate, ()=>{}, ()=>{}).subscribe(
      res => {
      var downloadURL = window.URL.createObjectURL(res);
      var link = document.createElement('a');
      link.href = downloadURL;

      let fileName = "export_reservations.csv";
      link.download = fileName;
      link.click();
    },
      err => {
        this.translate.get('generate-report-error').subscribe((error: string) => {
          this.translate.get('repeat').subscribe((res: string) => {
            this.toastr.error(res, error);
          });
        });
      }
    );
  }

  getRange(range: Date[]) {
    this.startDate = range[0];
    this.endDate = range[1];
  }
}

